import * as Sentry from '@sentry/browser';
import { AppConfig, appConfig } from '../config/app.config';
import { QuizEvent } from '../enums/quiz-event.enum';
import { IPostMessage } from '../interfaces/post-message.interface';

export class PostMessageService {
  constructor(private readonly appConfig: AppConfig) {
    window.addEventListener('message', this.handlePostMessage);
  }

  private subscriptions: Array<{ event: QuizEvent, callback: (message: IPostMessage) => void }> = [];

  public send({ event, data }: Pick<IPostMessage, "event" | "data">) {
    const postMessage: IPostMessage = { 
      event, data, 
      access_key: appConfig().access_key
    };

    try {
      window?.top?.postMessage(JSON.stringify(postMessage), '*');

    } catch (e) {
      Sentry.captureException(e);
    }
  }

  public subscribe(event: QuizEvent, callback: (data: any) => void) {
    this.subscriptions.push({ event, callback });
  }

  private handlePostMessage = ({ data }: any) => {
    try {
      var message:IPostMessage = JSON.parse(data);
    } catch (e) { return }
    
    if (message?.access_key != this.appConfig.access_key) return;

    this.subscriptions.filter(sub => sub.event == message.event).forEach(sub => sub.callback(message));
  }
}

export const postMessageService = new PostMessageService(appConfig());